import { toast } from "react-toastify";
import { postLoginInstance, preLoginInstance } from "../../utils";
import { API_LIMIT, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllEventData } from "./EventsAction";
import { getLabelByValue, filterVerifiedItems } from "../../utils/ReusableFunctions";


export const getAllEventDataApi = (ctx = null) => {

  return function (dispatch, getState) {
    ctx?.setState?.({ isLoading: true })
    let match = new URLSearchParams(ctx?.props?.location?.search);
    const searchParam = match.get("search") || "";
    const verifyUrl = match.get("isVerified") || "";
    const pageSize = match.get("pageSize") ? match.get("pageSize") : "";
    const pageNumber = match.get("page") ? match.get("page") : "";
    const query = new URLSearchParams({
      ...(verifyUrl ? { isVerified: verifyUrl } : {}),
      ...(searchParam ? { searchValue: searchParam } : {}),
      pageSize: pageSize || API_LIMIT,
      pageNumber: pageNumber || START_PAGE
    }).toString();

    return postLoginInstance.get(`events?${query}`)
      .then((res) => {

        dispatch(getAllEventData(res.data.data, ctx?.state?.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false})
      }
      )
  }

};

export const addEventApi = (data, ctx, onHide) => {
  return postLoginInstance.post("events", data).then((res) => {
    ctx.props.getAllEventDataApi(null, onHide);
  })
    .catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
};
export const deleteEventApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`events/${id}`).then((res) => {
    ctx.props.getAllEventDataApi(null, onHide);
  }).catch((error) => {
    toast.error(error?.response?.data?.message || "Something went wrong")
  })
};
export const updateEventApi = (data, ctx, onHide, id) => {
  return postLoginInstance.put(`events/${id}`, data).then((res) => {
    ctx.props.getAllEventDataApi(null, onHide);
  }).catch((error) => {
    toast.error(error?.response?.data?.message || "Something went wrong")
  })
};



export const getEventOrganiserApi = (ctx) => {
  return postLoginInstance.get(`eventOrganiser`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.eventOrganiserName,
          value: item.uuid
        }));
      ctx.setState({
        eventOrganiserOptions: option
      })
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
}
export const getEventCategoryApi = (ctx) => {
  return postLoginInstance.get(`eventCategory`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.eventCategoryName,
          value: item.uuid
        }));
      ctx.setState({
        eventCategoryOptions: option
      })
    })
}

export const getEventSpeakerApi = (ctx) => {
  return postLoginInstance.get(`eventSpeaker`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.speakerName,
          value: item.uuid
        }));
      ctx.setState({
        eventSpeakerOptions: option
      })
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
}
export const getAllEventsApi = (ctx) => {
  return postLoginInstance.get(`events?pageSize=${MAX_LIMIT}&pageNumber=1`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.name,
          value: item.uuid
        }));
      ctx.setState({
        eventOptions: option
      })
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
}

export const getEventsByFilterApi = async (filter) => {

  const params = {
    pageNumber: 1,
    pageSize: MAX_LIMIT,
  }
  const amcUuidArr = filter?.amc ? filter?.amc : null
  const createrUuidArr = filter?.creater ? filter?.creater : null

  const amcArr = amcUuidArr?.map((item) => {
    return getLabelByValue(item, filter?.amcOptions) || null;
  })

  const createrArr = createrUuidArr?.map((item) => {
    return getLabelByValue(item, filter?.createrOptions) || null;
  })

  if (amcArr?.length > 0) {
    params.amc = amcArr?.join(",")
  }
  if (createrArr?.length > 0) {
    params.creator = createrArr?.join(",")
  }

  try {
    const response = await postLoginInstance.get(`events`, {
      params
    });
    if (response.status < 250 && response.status > 199) {
      return filterVerifiedItems(response.data.data.list);
    }
    return false;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
    return false;
  }
}
export const getAllCitesApi = (ctx) => {
  return postLoginInstance.get(`website/location/allCities?pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}  ${ctx?.state.locationSearch && `&searchValue=${ctx?.state.locationSearch}`}`)
    .then((res) => {
      let option = [];

      res.data.data.sort().map((item) =>
        option.push({
          label: item,
          value: item
        }))
      ctx.setState({
        allCities: option
      })
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
}
export const getAmcApi = (ctx) => {
  return postLoginInstance.get(`amc`)
    .then((res) => {
      const option = filterVerifiedItems(res.data.data.list).map((item) => ({
          label: item.amcName,
          value: item.uuid
        }));
      ctx.setState({
        amcOption: option
      })
    }).catch((error) => {
      toast.error(error?.response?.data?.message || "Something went wrong")
    })
};
